// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle__dot{top:-.25rem;left:-.25rem;transition:all .3s ease-in-out}input:checked~.toggle__dot{transform:translateX(100%);background-color:#48bb78}", ""]);
// Exports
module.exports = exports;
